import {useLazyQuery} from '@apollo/client/react';
import {ModuleTopic} from '@cp/model';
import {GET_MODULE_TOPICS_WITH_STUDY} from '../sharedQueries';

export interface GetModuleTopicsWithStudyVariables {
  moduleId: string;
}

export function useGetModuleTopicsWithStudy() {
  const [fetchTopics, {data, loading, error}] = useLazyQuery<
    {getModuleTopicsWithStudy: ModuleTopic[]},
    GetModuleTopicsWithStudyVariables
  >(GET_MODULE_TOPICS_WITH_STUDY);

  const getModuleTopicsWithStudy = (moduleId: string) => {
    return fetchTopics({
      variables: {moduleId},
    });
  };

  return {
    topics: data?.getModuleTopicsWithStudy || [],
    loading,
    error,
    getModuleTopicsWithStudy,
  };
}
